<template>
	<nk-wrapper v-if="context" id="results" spacing="md">
		<section id="results">
			<nk-list variant="overview">
				<nk-list-item
					v-for="(brancheneintrag, brancheneintragIndex) in context"
					:key="`brancheneintrag-${brancheneintragIndex}-${brancheneintrag.id}`"
				>
					<article>
						<nk-row gutter="3" vertical-gutter="2">
							<nk-col cols="full" order="2" sm="auto" order-sm="1">
								<nk-list v-if="!options.hideCategory" variant="horizontal">
									<nk-list-item
										v-for="(rubrik, rubrikIndex) in brancheneintrag.rubriken"
										:key="rubrikIndex"
										icon="library"
									>
										{{ rubrik.rubrik }}
									</nk-list-item>
								</nk-list>

								<nk-link :link="brancheneintrag.rubriken[0].detailURL" block>
									<nk-title
										max-lines="2"
										size="lg"
										tag="h1"
										:no-margin="
											brancheneintrag.spezialisierung &&
											!options.hideSpecialization
										"
									>
										{{ brancheneintrag.titel }}
									</nk-title>
								</nk-link>

								<nk-text
									v-if="
										brancheneintrag.spezialisierung &&
										!options.hideSpecialization
									"
								>
									{{ brancheneintrag.spezialisierung }}
								</nk-text>

								<nk-address
									variant="vertical"
									:telefon="brancheneintrag.kontakt.telefon"
									:email="brancheneintrag.kontakt.email"
									:link="brancheneintrag.kontakt.link"
									:linktext="brancheneintrag.kontakt.linktext"
									:plz="
										brancheneintrag.zeige_adresse && brancheneintrag.adresse.plz
											? brancheneintrag.adresse.plz
											: null
									"
									:ort="
										brancheneintrag.zeige_adresse && brancheneintrag.adresse.ort
											? brancheneintrag.adresse.ort
											: null
									"
									:strasse="
										brancheneintrag.zeige_adresse &&
										brancheneintrag.adresse.strasse
											? brancheneintrag.adresse.strasse
											: null
									"
									:geokoordinaten="
										brancheneintrag.zeige_adresse &&
										brancheneintrag.adresse.geokoordinaten
									"
								/>
							</nk-col>
							<nk-col
								v-if="
									getBranchenImageKey(brancheneintrag, 'bild') &&
									options.showImages
								"
								cols="full"
								order="1"
								sm="4/12"
								order-sm="2"
							>
								<nk-link
									:link="brancheneintrag.rubriken[0].detailURL"
									block
									tabindex="-1"
								>
									<nk-image
										:src="getBranchenImageKey(brancheneintrag, 'bild')"
										:alt="getBranchenImageKey(brancheneintrag, 'bildtext')"
										:copyright="
											getBranchenImageKey(brancheneintrag, 'bildcopyright')
										"
										:ar="options.variableImageHeight ? null : '4:3'"
										image-class="w-full"
										:no-cache="true"
									/>
								</nk-link>
							</nk-col>
						</nk-row>
					</article>
				</nk-list-item>
			</nk-list>
		</section>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {array} context
 * @prop {boolean} options.showImages
 * @prop {boolean} options.hideSpecialization
 * @prop {boolean} options.gastro
 * @prop {Boolean} options.variableImageHeight
 */
export default {
	name: 'NkTemplateBrancheneintraege',

	mixins: [TemplatesDefault],

	methods: {
		getBranchenImageKey(brancheneintrag, key) {
			if (this.options.gastro) {
				return brancheneintrag[`${key}2`];
			}
			return brancheneintrag[key];
		},
	},
};
</script>
